export const sideBarWidth = '40%';
